import { useCallback, useMemo } from "react";
import { useSearch, useNavigate } from "@tanstack/react-router";
import type { AdminSearchParams } from "@/features/admin/types";
import type { AttributeSortField, AttributeSortDirection } from "./attributeUtils";

export function useAttributesSearchParams() {
  const search = useSearch({
    from: "/admin",
  }) as AdminSearchParams;
  const navigate = useNavigate({ from: "/admin" });

  const sorting = useMemo(() => {
    const sortColumn = search.attributesSortBy as AttributeSortField | undefined;
    const sortDirection = (search.attributesSortDirection ?? "asc") as AttributeSortDirection;
    return {
      sortField: sortColumn ?? ("name" as AttributeSortField),
      sortDirection,
    };
  }, [search.attributesSortBy, search.attributesSortDirection]);

  const updateSearchParams = useCallback(
    (updates: { sortField?: AttributeSortField; sortDirection?: AttributeSortDirection }) => {
      const newSearch: AdminSearchParams = { ...search };

      if (updates.sortField === undefined) {
        delete newSearch.attributesSortBy;
        delete newSearch.attributesSortDirection;
      } else {
        newSearch.attributesSortBy = updates.sortField;
        newSearch.attributesSortDirection = (updates.sortDirection ?? "asc") as "asc" | "desc";
      }

      navigate({
        search: newSearch,
        replace: true,
      });
    },
    [search, navigate]
  );

  return {
    sorting,
    updateSearchParams,
  };
}
